import { useParams } from "react-router-dom";

type SettingsPageParams = {
  profileId: string;
};

export const useSelectedProfileId = (): string => {
  const { profileId } = useParams<SettingsPageParams>();

  return profileId;
};
